<script setup lang="ts">
withDefaults(
  defineProps<{
    theme?: 'primary' | 'secondary' | 'tertiary' | 'text' | 'link' | 'error' | 'outline' | 'surface' | 'confirm';
    type?: 'button' | 'submit';
    disabled?: boolean;
  }>(),
  {
    type: 'button',
    theme: 'primary',
    disabled: false,
  },
);
</script>

<template>
  <button
    :type="type"
    :disabled="disabled"
    :class="[
      'flex gap-[8px] h-button items-center',
      'rounded-button border-1',
      'px-[16px] py-[8px]',
      'transition duration-300',
      'font-semibold',
      'focus-visible:outline-focus focus-visible:outline-offset-[3px]',
      theme === 'primary' && [
        'text-on-tint',
        'border-tint',
        'bg-tint',
        'hover:border-tint-hover',
        'hover:bg-tint-hover',
        'active:bg-tint-active',
        'disabled:bg-surface-tertiary',
        'disabled:border-tertiary',
        'disabled:text-secondary',
      ],
      theme === 'secondary' && [
        'text-primary',
        'bg-surface-primary',
        'border-divider',
        'hover:bg-surface-secondary',
        'active:bg-surface-tertiary',
        'disabled:text-secondary',
      ],
      theme === 'error' && [
        'text-error',
        'border-divider',
        'hover:bg-transparent',
        'hover:text-secondary',
        'disabled:text-secondary',
      ],
      theme === 'link' && [
        'text-link',
        '!font-normal',
        'underline',
        'underline-offset-[4px]',
        'border-0',
        '!py-0',
        'px-1',
        '!h-min',
        'hover:border-tint-hover',
        'hover:text-tint-hover',
        'focus-visible:outline-offset-[4px]',
        'disabled:text-tertiary',
      ],
      theme === 'text' && [
        'text-tint',
        'border-transparent',
        'bg-transparent',
        'hover:text-tint-hover',
        'active:text-tint-active',
        'disabled:text-secondary',
      ],
      theme === 'outline' && ['text-on-tint', 'border-divider', 'hover:bg-tint-hover', 'active:bg-tint-active'],
      theme === 'surface' && [
        'border-0 flex items-center justify-center shrink-0',
        'transition duration-300',
        'outline-inner',
        'bg-surface-secondary ',
        'active:bg-tint active:text-white hover:bg-primary/20',
        'disabled:bg-surface-secondary',
        'disabled:text-secondary',
      ],

      theme === 'tertiary' && ['text-tint', 'bg-tertiary', 'hover:bg-tertiary-hover', 'active:bg-tertiary-active'],
      theme === 'confirm' && [
        'text-on-tint',
        'outline-inner',
        'bg-surface-green',
        'hover:bg-surface-green/80',
        'active:bg-surface-green/20',
      ],
    ]"
  >
    <slot></slot>
  </button>
</template>
